import { Action } from 'redux';
import { action } from 'typesafe-actions';

import { OverlayTypes } from './types';

export const setOverlayActive = (isOverlayActive: boolean): Action =>
  action(OverlayTypes.SET_OVERLAY_ACTIVE, { isOverlayActive });
